import { NgModule } from '@angular/core';
import { MenuModule } from '../menu/menu.module';
import { SharedModule } from '../shared/shared.module';
import { CommentComponent } from './comment.component';
import { EditCommentComponent } from './edit-comment/edit-comment.component';



@NgModule({
  declarations: [CommentComponent, EditCommentComponent],
  imports: [  
    SharedModule,
    MenuModule
  ],
  exports:[
    CommentComponent,
    EditCommentComponent
  ]
})
export class CommentModule { }
 